/* @ngInject */
const format = (
  utils,
  wagonUtils,
  wagonTest,
  valueHandler
) => {
  const self = {}

  self.user = (_wagon) => {
    const wagon = utils.copy(_wagon)
    wagon.id = wagonUtils.idToString(_wagon.id)
    wagon.idNew = wagonUtils.idToString(_wagon.idNew)

    wagon.revisionDate = utils.date.timestampToString(_wagon.revisionDate)

    wagon.comment = utils.removeHtmlLineBreak(_wagon.comment)
    wagon.isolatedComment = utils.removeHtmlLineBreak(_wagon.isolatedComment)
    wagon.damagedComment = utils.removeHtmlLineBreak(_wagon.damagedComment)

    if (valueHandler.isArray(wagon.dispositions)) {
      for (let index = 0; index < wagon.dispositions.length; index++) {
        if (valueHandler.isObject(wagon.dispositions[index])) {
          wagon.dispositions[index].date = utils.date.timestampToString(wagon.dispositions[index].date)
        }
      }
    }

    return wagon
  }

  self.server = (_wagon) => {
    const wagon = utils.copy(_wagon)
    wagon.id = wagonUtils.stringToId(_wagon.id)
    wagon.idNew = wagonUtils.stringToId(_wagon.idNew)

    wagon.revisionDate = utils.date.stringToServer(_wagon.revisionDate)
    wagon.revisionDateBegin = utils.date.stringToServer(_wagon.revisionDateBegin)
    wagon.revisionDateEnd = utils.date.stringToServer(_wagon.revisionDateEnd)

    wagon.trainDateBegin = utils.date.stringToServer(_wagon.trainDateBegin)
    wagon.trainDateEnd = utils.date.stringToServer(_wagon.trainDateEnd)

    wagon.dateIntervalBegin = utils.date.stringToServer(_wagon.dateIntervalBegin)
    wagon.dateIntervalEnd = utils.date.stringToServer(_wagon.dateIntervalEnd)

    wagon.scrappingDate = utils.date.stringToServer(_wagon.scrappingDate)

    if (wagon.length) {
      wagon.length = wagon.length.toString().replace(/,/g, '.')
    }
    if (wagon.tare) {
      wagon.tare = wagon.tare.toString().replace(/,/g, '.')
    }
    if (wagon.capacity) {
      wagon.capacity = wagon.capacity.toString().replace(/,/g, '.')
    }
    if (wagon.brakedMass) {
      wagon.brakedMass = wagon.brakedMass.toString().replace(/,/g, '.')
    }
    if (wagon.feet) {
      wagon.feet = wagon.feet.toString().replace(/,/g, '.')
    }

    if (valueHandler.isArray(wagon.dispositions)) {
      for (let index = 0; index < wagon.dispositions.length; index++) {
        if (valueHandler.isObject(wagon.dispositions[index])) {
          wagon.dispositions[index].date = utils.date.stringToServer(wagon.dispositions[index].date)
        }
      }
    }

    return wagon
  }

  self.excel = (_wagon) => {
    const wagon = utils.copy(_wagon)

    const date = utils.date.timestampToString(wagon.revisionDate)

    if (wagon.revision) {
      wagon.completeRevision = wagon.step + ' REV ' + wagon.revision + ' ' + date + (wagon.extendRevision ? ' + ' + wagon.extendRevision + 'M' : '')
    }

    if (!wagonTest.isRevisionOk(wagon.revisionDate, wagon.step, wagon.extendRevision)) {
      wagon.revisionBadge = 'Révision'
    }
    if (!wagonTest.isDateTrainOk(wagon.arrivalDate)) {
      wagon.dateBadge = 'Date'
    }

    return wagon
  }

  return self
}

export default format



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/services/format.service.js